/* 检查浏览器ua判断环境，不包含用户通过修改浏览器设置伪造ua的情况 */
// 与ua有关的方法和属性都在这里
export const extendUA = {
  _ua: window.navigator.userAgent.toLowerCase(),
  /* mobile */
  // 是否是是安卓
  get isAndroid() {
    return this._ua.includes('android') || this._ua.includes('adr')
  },
  // 是否是ios
  get isIOS() {
    return this._ua.includes('like mac os x')
  },
  /* wechat */
  // 是否在微信中
  get isWechat() {
    return this._ua.includes('micromessenger')
  },
  // 是否在微信中且是ios
  get isWechatAndroid() {
    return this.isWechat && this.isAndroid
  },
  // 是否在微信中且是android
  get isWechatIOS() {
    return this.isWechat && this.isIOS
  },
  /* alipay */
  // 是否在支付宝中
  get isAlipay() {
    return this._ua.includes('alipay')
  },
  // 是否在支付宝中且是android
  get isAlipayAndroid() {
    return this.isAlipay && this.isAndroid
  },
  // 是否在支付宝中且是ios
  get isAlipayIOS() {
    return this.isAlipay && this.isIOS
  },
  // 获取操作系统名称
  get osName() {
    let os = 'other'
    if (this.isIOS) {
      os = 'ios'
    } else if (this.isAndroid) {
      os = 'android'
    }
    return os
  },
  // 获取操作系统版本
  get osVersion() {
    const ua = this._ua
    let version = ''
    if (this.isIOS) {
      let match = ua.match(/cpu iphone os (.*?) like mac os/)
      if (!match) return ''
      version = match[1].replace(/_/g, '.')
    } else if (this.isAndroid) {
      let match = ua.match(/(?:android|adr) (.*?);/i)
      if (!match) return ''
      version = match[1]
    }
    return version
  },
  /* 口袋故事app中可以使用的方法 */
  // 是否在口袋故事app中
  get isIlisten() {
    return this.isIlistenAndroid || this.isIlistenIOS
  },
  // 是否在口袋故事app中并且是android系统
  get isIlistenAndroid() {
    return this._ua.includes('ilisten_android')
  },
  // 是否在口袋故事app中并且是ios系统
  get isIlistenIOS() {
    return this._ua.includes('ilisten_ios')
  },
  // 获取 app caller
  get ilistenCaller() {
    let defaultCaller = '1002'
    const ua = this._ua
    let reg = /\(\/ilisten_(.*)\)/i
    let match = ua.match(reg)
    if (!match) return defaultCaller
    let info = match[1].split('_')
    let caller = info[1]
    if (!caller) return defaultCaller
    return caller
  },
  // 获取 app 版本
  get ilistenVersion() {
    let defaultVersion = '1.0.0'
    const ua = this._ua
    let reg = /\(\/ilisten_(.*)\)/i
    let match = ua.match(reg)
    if (!match) return defaultVersion
    let info = match[1].split('_')
    let prdVer = info[2]
    if (!prdVer) return defaultVersion
    return prdVer
  },
  // 获取 app 渠道
  get ilistenMarketChannel() {
    let defaultChannel = 'appshare'
    const ua = this._ua
    let reg = /\(\/ilisten_(.*)\)/i
    let match = ua.match(reg)
    if (!match) return defaultChannel
    let info = match[1].split('_')
    let channel = info[3]
    if (!channel) return defaultChannel
    return channel
  },
  // 比较两个版本的大小，前者大于后者时，返回1，相等时返回0，否则返回-1
  compareVersion(v1, v2) {
    v1 = v1.split('.')
    v2 = v2.split('.')
    const len = Math.max(v1.length, v2.length)

    while (v1.length < len) {
      v1.push('0')
    }
    while (v2.length < len) {
      v2.push('0')
    }

    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i])
      const num2 = parseInt(v2[i])
      if (num1 > num2) {
        return 1
      } else if (num1 < num2) {
        return -1
      }
    }
    return 0
  }
}
